import { message as Message } from 'antd';
import httpClient from '../util/httpClient';
import { GLOBAL_API_DOMAIN } from '../config';

async function commonLogin(params) {
    let data = await httpClient.post('common-api/login', params);
    return data;
}

async function logout() {
    let data = await httpClient.post('common-api/logout');
    return data;
}

/**
 * 返回超管
 */
async function returnToSysAdmin() {
    let data = await httpClient.post('common-api/return-to');
    return data;
}

/**
 * 修改密码
 * @param {Object} params
 */
async function updatePassword(params, identity) {
    // 默认是超管/普管
    let url = 'manage-api/v4/change-pwd'
    if (identity.includes("Merchant")) {
        url = 'merchant-api/v4/change-pwd'
    }
    let data = await httpClient.post(url, params);
    return data;
}

/*
 *
 *校验手机验证码
 */

async function checkPhone(params, identity) {
    let url = 'manage-api/v4/check-phone-no'
    if(identity.includes("Merchant")) {
      url = 'merchant-api/v4/check-phone-no'
    }
    let data = await httpClient.post(url, params);
    return data;
}

/*
  发送验证码
*/

async function sendCode(params, identity) {
    let url = 'manage-api/v4/send/phone-code';
    if(identity.includes("Merchant")) {
      url = 'merchant-api/v4/send/phone-code'
    }
    let data = await httpClient.get(url, {params});
    return data;
}

/*
  管理员解绑支付宝绑定
*/

async function unbindOpenid(params, identity) {
    let url = 'manage-api/v4/unbind-openid'
    if(identity.includes("Merchant")) {
      url = 'merchant-api/v4/unbind-openid'
    }
    let data = await httpClient.post(url, params);
    return data;
}

/*
  绑定或者更换手机号
*/
async function updatePhone(params, identity) {
    let url = 'manage-api/v4/update-phone'
    if(identity.includes("Merchant")) {
      url = 'merchant-api/v4/update-phone'
    }
    let data = await httpClient.post(url, params);
    return data;
}

/**
 * 获取二维码URL
 */
async function getQRCodeSrc(params) {
    if (!params.method) {
        params.method = "GET";
    }
    let { result, status } = await httpClient(params);
    return status === 200 ? result : ''
}

/**
 * 校验二维码有效性
 * @param {QRCodeSrc} code
 */
async function checkQRCodeStatus(code) {
    let data = await httpClient.post(`qrcode/check-up`, { code });
    return data;
}

/**
 * 扫码登录检验是否有两个身份 admin&Merchant
 */
async function checkQRcodeIdentity(identity) {
    let data = await httpClient.post(`qrcode/identity?identity=` + identity);
    return data;
}

/**
 * 跳过支付宝绑定
 */
async function skipBind() {
    let data = await httpClient.post(`api/admin/skip-bind`);
    return data;
}

/**
 * 获取用户基础信息(identity用来判断用户身份;source用来判断是否由超管跳转)
 */
async function getUserBaseInfo() {
    let { result, status } = await httpClient.get(`common-api/login-info`);
    return status === 200 ? result : {}
}


/**
 * 获取用户菜单信息
 */
async function getAdminMenu() {
    let { result, status } = await httpClient.get(`api/admin-model/get-org-model`);
    let statis = {}
    if (status === 200) {
        statis = result
    }
    return statis;
}
/**
 * 获取商户菜单信息
 */
async function getMerchantMenu(orgId) {
    // let { result, status } = await httpClient.get(`api/admin-model/mer-get-model-by-orgId?orgId=` + orgId);
    let { result, status } = await httpClient.get(`api/admin-model/mer-get-model?orgId=` + orgId);
    let statis = {}
    if (status === 200) {
        statis = result
    }
    return statis;
}
/**
 * 获取用户权限信息
 */
async function getUserAuthInfo(identity, orgId) {
    if (identity.includes("Admin")) {
        // (bindSkipped来判断本次登录是否跳过了绑定支付宝流程;aliuserId是判断是否绑定支付宝;aliAuthed的判断是否通过扫码认证/登录)
        let { result, status } = await httpClient.get(`api/admin/me`);
        return status === 200 ? result : {}
    } else if (identity.includes("Merchant")) {
        let { result, status } = await httpClient.get(`merchant-api/v2/me`, { params: { org: orgId } });
        return status === 200 ? result : {}
    } else if (identity.includes("Agent")) {
        let { result, status } = await httpClient.post(`agent-api/v4/me`);
        return status === 200 ? result : {}
    }
}

/**
 * 获取登录用户收款账户列表
 */
async function getPaySetList(identity, orgId) {
    if (identity.includes("Admin")) {
        let { result, status } = await httpClient.get(`api/pay-set/list`);
        return status === 200 ? result : { aliPaySet: [], bestPaySet: [], uniPayPaySet: [], wxPaySet: [] }
    } else if (identity.includes("Merchant")) {
        let params = { orgId }
        let { result, status } = await httpClient.get(`merchant-api/v2/pay-set/list`, { params });
        return status === 200 ? result : { aliPaySet: [], bestPaySet: [], uniPayPaySet: [], wxPaySet: [] }
    }
}

/**
 * 概览=>获取数据概览
 */
async function getOverViewDataStatis() {
    let { result, status } = await httpClient.get(`api/statis/index`);
    let statis = {}
    if (status === 200) {
        statis = result
    }
    return statis;
}


/**
 * 概览=>获取收款统计
 */
async function getOverViewDailySales(params) {
    let { result, status } = await httpClient.get(`manage-api/v4/daily-sales`, { params });
    return status === 200 ? result : []
}

/**
 * 概览=>获取收款排行
 */
async function getOverViewDayRank(params) {
    let { result, status } = await httpClient.get(`manage-api/v4/day-rank`, { params });
    return status === 200 ? result : []
}
/**
 * 交易流水=>获取食堂列表
 */
async function getCanteenList(params, identity, orgId, type) {
    if (identity.includes("Merchant")) {
        var param = { org: orgId };
        if(type) {
          param = { org: orgId, all: false}
        }
        let { result, status } = await httpClient.get(`merchant-api/v2/org-tree`, { params: param });
        return status === 200 ? result : {}
    } else {
        let { result, status } = await httpClient.get(`api/device/tree`, { params });
        return status === 200 ? result : {}
    }
}
/**
 * 交易流水=>获取支付方式
 */
async function getPayChannel() {
    let { result, status } = await httpClient.get(`manage-api/get-pay-channel-enum`);
    return status === 200 ? result : []
}

/**
 * 交易流水=>获取订单列表
 * @param {*} params
 */
async function getOrderList(params, identity, orgId, activeTabKey) {
    let url = ''
    if (identity.includes("Merchant")) {
        params.org = orgId
        if (activeTabKey === 'recent') {
            url = `merchant-api/v2/order-list`
        } else {
            url = `merchant-api/v2/history/order-list`
        }
    } else {
        if (activeTabKey === 'recent') {
            url = `api/order/list`
        } else {
            url = `api/order/history/list`
        }
    }
    return await httpClient.get(url, { params });
}

/**
 * 交易流水=>发起退款请求
 * @param {订单号} orderNo
 * @param {退款金额(分)} value
 */
async function submitRefund(orderNo, value, identity, orgId, remark) {
    let params = { orderNo, value, remark };
    if(remark === '') {
      params = { orderNo, value };
    }
    if (identity.includes("Merchant")) {
        let data = await httpClient.post(`merchant-api/v2/refund`, params);
        return data;
    } else {
        let data = await httpClient.post(`api/order/refund`, params);
        return data;
    }
}

/**
 * 食堂管理=>获取设备列表
 * @param {*} params
 */
async function getDeviceList(params, identity, orgId) {
    if (identity.includes("Merchant")) {
        params.org = orgId
        let { result, status } = await httpClient.get(`merchant-api/v2/device-list`, { params });
        return status === 200 ? result : []
    } else {
        let { result, status } = await httpClient.get(`api/device/list`, { params });
        return status === 200 ? result : []
    }
}

/**
 * 添删改查设备
 * @param {*} params
 */
async function CRUD_Device(params) {
    return await httpClient(params);
}

/**
 * 添删改查档口
 * @param {*} params
 */
async function CRUD_Window(params) {
    return await httpClient(params);
}

/**
 * 添删改查食堂
 * @param {*} params
 */
async function CRUD_Centeen(params) {
    return await httpClient(params);
}

/**
 * 添删改查商户
 * @param {*} params
 */
async function CRUD_Merchant(params) {
    return await httpClient(params);
}

/**
 * 食堂管理=>获取校园卡列表
 */
async function getECardTypes(identity, orgId) {
    let params = {}
    if (identity.includes("Merchant")) {
        params.orgId = orgId
    }
    let { result, status } = await httpClient.get(`api/ecard/types`, { params });
    return status === 200 ? result : []
}

/**
 * 食堂管理=>获取机具品牌
 */
async function getBrand() {
    let params = {}
    let { result, status } = await httpClient.get(`v2/brand/list`, { params });
    return status === 200 ? result : []
}

/**
 * 高级餐补=>获取餐补列表
 */
async function getCanbuList(identity, orgId) {
    if (identity.includes("Merchant")) {
        let { result, status } = await httpClient.get(`merchant-api/v2/canbu/list`, { params: { org: orgId } });
        return status === 200 ? result : []
    } else {
        let { result, status } = await httpClient.get(`manage-api/canbu/list`);
        return status === 200 ? result : []
    }
}

/**
 * 弱网支付=>获取订单管理
 */
async function getWeakOrderList(params, identity, orgId) {
    if (identity.includes("Merchant")) {
        let result = await httpClient.post(`api/offline-order/page-list?type=ME`, params);
        return result
    } else {
        let result = await httpClient.post(`api/offline-order/page-list`, params);
        return result
    }
}
/**
 * 弱网支付=>获取单个订单管理
 */
async function getWeakOrderOne(params, identity, orgId) {
    if (identity.includes("Merchant")) {
        let result = await httpClient.get(`api/offline-order/get-by-id`, {params});
        return result
    } else {
        let result = await httpClient.get(`api/offline-order/get-by-id`, {params});
        return result
    }
}

/**
 * 弱网支付=>获取机具管理
 */
async function getWeakDeviceList(params, identity, orgId) {
    if (identity.includes("Merchant")) {
        let result = await httpClient.post(`api/device/report/page-list?type=ME`, params);
        return result
    } else {
        let result = await httpClient.post(`api/device/report/page-list`, params);
        return result
    }
}

/**
 * 弱网支付=>获取黑名单管理
 */
async function getWeakBlackList(params, identity, orgId) {
    if (identity.includes("Merchant")) {
        let result = await httpClient.post(`api/device/user-limit/page-list?type=ME`, params);
        return result
    } else {
        let result = await httpClient.post(`api/device/user-limit/page-list`, params);
        return result
    }
}
/**
 * 弱网支付=>手动扣费
 */
async function setWeakPay(params, identity) {
  if (identity.includes("Merchant")) {
    let result = await httpClient.get(`api/offline-order/create-pay?type=ME`, {params});
    return result
  } else {
    let result = await httpClient.get(`api/offline-order/create-pay`, {params});
    return result
  }
}

/**
 * 弱网支付=>移除黑名单
 */
 async function weakRemoveId(params, identity, orgId) {
   let result = await httpClient.get(`api/user/limit/remove-by-id`, {params});
   return result
 }

/**
 * 食堂管理=>获取支付方式列表ByOrgCode
 */
async function getPayChannelByOrgCode(identity, orgId) {
    let params = {}
    if (identity.includes("Merchant")) {
        params.orgId = orgId
    }
    let { result, status } = await httpClient.get(`manage-api/get-pay-channel-byOrgCode`, { params });
    if (status === 200) {
        let index = result.findIndex(item => item.payChannel === '')
        result.unshift(result.splice(index, 1)[0])
        return result
    } else {
        return []
    }
}

async function getDeviceQRCode(params) {
    let { result, status } = await httpClient.get(`api/device/download-qr-uri`, { params });
    return status === 200 ? result : ''
}

/**
 * 餐补管理=>新增餐补
 */
 async function getCbChannel(identity, orgId) {
     let params = {}
     if (identity.includes("Merchant")) {
         params.orgId = orgId
     }
     let { result, status } = await httpClient.get(`api/org/new/cb/pay-from-type`, { params });
     if (status === 200) {
         return result
     } else {
         return {}
     }
 }
/**
 * 餐补管理=>新增餐补
 */
 async function addCb(params, identity, orgId) {
   if (identity.includes("Merchant")) {
      params.orgId = orgId;
      return await httpClient.post(`api/org/new/cb/merchant/add`, params);
   } else {
      return await httpClient.post(`api/org/new/cb/add`, params);
   }
 }
/**
 * 餐补管理=>删除餐补
 */
 async function delCb(params, identity, orgId) {
     if (identity.includes("Merchant")) {
        params.orgId = orgId;
        return await httpClient.get(`api/org/new/cb/merchant/delete-by-cb-id`, {params});
     } else {
        return await httpClient.get(`api/org/new/cb/delete-by-cb-id`, {params});
     }
 }
/**
 * 餐补管理=>删除餐补子规则
 */
 async function delCbRule(params, identity, orgId) {
     if (identity.includes("Merchant")) {
        params.orgId = orgId;
        return await httpClient.get(`api/org/new/cb/merchant/delete-by-cb-item-id`,{params});
     } else {
        return await httpClient.get(`api/org/new/cb/delete-by-cb-item-id`, {params});
     }
 }
/**
 * 餐补管理=>获取单个餐补
 */
 async function getCbOne(params, identity, orgId) {
     if (identity.includes("Merchant")) {
          params.orgId = orgId;
         let { result, status } = await httpClient.get(`api/org/new/cb/merchant/get-by-cb-id`, {params});
         return status === 200 ? result : []
     } else {
         let { result, status } = await httpClient.get(`api/org/new/cb/get-by-cb-id`, {params});
         return status === 200 ? result : []
     }
 }
/**
 * 餐补管理=>查询规则
 */
 async function getCbRule(identity, orgId) {
     if (identity.includes("Merchant")) {
         let { result, status } = await httpClient.get(`api/org/new/cb/merchant/get-cb-list`, { params: { orgId: orgId } });
         return status === 200 ? result : []
     } else {
         let { result, status } = await httpClient.get(`api/org/new/cb/get-cb-list`);
         return status === 200 ? result : []
     }
 }
/**
 * 餐补管理=>餐补管理列表
 */
 async function getCbList(params, identity, orgId) {
     if (identity.includes("Merchant")) {
          params.orgId = orgId;
         let { result, status } = await httpClient.get(`api/org/new/cb/merchant/get-list-by-org`, {params});
         return status === 200 ? result : []
     } else {
         let { result, status } = await httpClient.get(`api/org/new/cb/get-list-by-org`);
         return status === 200 ? result : []
     }
 }
/**
 * 餐补管理=>更新餐补
 */
 async function updateCbOne(params, identity, orgId) {
     if (identity.includes("Merchant")) {
        params.orgId = orgId;
        return await httpClient.post(`api/org/new/cb/merchant/update`, params);
     } else {
        return await httpClient.post(`api/org/new/cb/update`, params);
     }
 }


/**
 * 对账单下载URL
 */
async function getStatementUrl(source, queryString) {
    let { status, message } = await httpClient.get(`api/order/downLoad/${source}/check/empty?${queryString}`);
    if (status === 200) {
        let url = window.location.origin + GLOBAL_API_DOMAIN + `api/order/downLoad/${source}/dailybill?${queryString}`
        return { status, result: url }
    } else {
        return { status, message }
    }
}
/**
 * 支付宝对账单下载URL
 * @param {*} data
 */
async function getAliPayStatementUrl(data, identity, orgId) {
    if (identity.includes("Merchant")) {
        data.org = orgId
        return await httpClient.post(`merchant-api/v2/bill-download`, data);
    } else {
        return await httpClient.post(`api/order/download`, data);
    }
}

/**
 * 资金管理=>获取订单列表
 * @param {*} data
 */
async function getFundsOrderList(data, identity, orgId) {
    if (identity.includes("Merchant")) {
        data.org = orgId
        let { result, status } = await httpClient.get(`merchant-api/v2/sale-statis`, { params: data });
        return status === 200 ? result : {}
    } else {
        let { result, status } = await httpClient.post(`manage-api/v2/sale-statis-v2`, data);
        return status === 200 ? result : []
    }
}
/**
 * 资金管理=>获取打印订单列表
 * @param {*} data
 */
async function getFundsDownOrderList(data, identity, orgId) {
  if (identity.includes("Merchant")) {
      data.org = orgId
      let { result, status } = await httpClient.post(`merchant-api/v2/sale-statis-v3`, data );
      return status === 200 ? result : {}
  } else {
      let { result, status } = await httpClient.post(`manage-api/v2/sale-statis-v3`, data);
      return status === 200 ? result : []
  }
}
/**
 * 资金管理=>下载打印订单列表
 * @param {*} data
 */
async function downFundsDownOrderList() {
      let { result, status } = await httpClient.get(`manage-api/v2/sale-statis-v3-download`);
      return status === 200 ? result : []
}

/**
 * 商户管理=>获取商户列表
 * @param {*} data
 */
async function getMerchantList(params) {
    let { result, status } = await httpClient.get(`api/merchant/list`, { params });
    return status === 200 ? result : []
}

/**
 * 获取商户所属学校列表
 */
async function getMerchantOrgList() {
    let { result, status } = await httpClient.get(`merchant-api/v2/org-list`);
    return status === 200 ? result : []
}

/**
 * 商户首次支付宝扫码登录后需账户绑定
 * @param {Object} data
 */
async function bindMerchantAccount(data) {
    return await httpClient.post(`merchant-api/v2/bind-account`, data);
}

/**
 * 学校管理=>获取学校列表
 * @param {Object} params
 */
async function getSchoolList(params, identity) {
    if (identity.includes("Agent")) {
        let { result, status } = await httpClient.get(`agent-api/v4/org-list`, { params });
        return status === 200 ? result : []
    } else {
        let { result, status } = await httpClient.get(`super-api/org-list`, { params });
        return status === 200 ? result : []
    }
}

/**
 * 学校管理=>获取支付宝用户信息
 * @param {String} id
 */
async function getAliUserInfo(id) {
    let { result, status } = await httpClient.get(`super-api/v3/ali-user`, { params: { id } });
    return status === 200 ? result : {}
}

/**
 * 学校管理=>解除支付宝用户绑定
 * @param {String} userName
 */
async function unBindAliUser(userName) {
    return await httpClient.post(`super-api/v3/admin/un-bind`, { userName });
}

/**
 * 学校管理=>添删改查商户(PM)
 * @param {Object} params
 */
async function CRUD_PM(params) {
    return await httpClient(params);
}

/*
  校园钱包/用户钱包充值记录
*/
async function getUserDepositRecord(params) {
    return await httpClient.get(`wallet/user/deposit/record`,{params});
}

/*
  校园钱包/学校钱包充值记录
*/
async function getOrgDepositRecord(params) {
    return await httpClient.get(`wallet/org/deposit/record`,{params});
}

/*
  校园钱包/查询学校当前余额
*/
async function getOrgBalance(params) {
    return await httpClient.get(`wallet/org/balance`,{params});
}

/*
  校园钱包/获取用户钱包充值详情
*/
async function getUserDepositDetail(params) {
    return await httpClient.get(`wallet/user/deposit/detail`,{params});
}

/*
  校园钱包/学校钱包充值详情
*/
async function getOrgDepositDetail(params) {
    return await httpClient.get(`wallet/org/deposit/detail`,{params});
}

/*
  校园钱包/用户钱包充值excel解析
*/
async function excelDetail(params) {
    let data = await httpClient.post('wallet/excel/detail', params);
    return data;
}
/*
  校园钱包/用户钱包充值excel解析
*/
async function userDeposit(params) {
    let data = await httpClient.post('wallet/user/deposit', params);
    return data;
}

/*
  校园钱包/学校钱包新建充值
*/
async function orgDeposit(params) {
    let data = await httpClient.post('wallet/org/deposit', params);
    return data;
}

/*
  校园钱包/学校钱包冲正
*/
async function orgDepositReverse(params) {
    let data = await httpClient.post('wallet/org/deposit/reverse', params);
    return data;
}

/*
  校园钱包/校园钱包概览
*/
async function getStatistic(params) {
    return await httpClient.get(`wallet/statistic`,{params});
}

/*
  校园钱包/校园钱包流水
*/
async function walletOrderList(params, identity, orgId) {
    if (identity.includes("Merchant")) {
      params["org"] = orgId;
      return await httpClient.get(`wallet/merchant/order/list`,{params});
    } else {
      return await httpClient.get(`wallet/admin/order/list`,{params});
    }

}

/*
  校园钱包/商户对账
*/
async function getWindowSale(params, identity, orgId) {
  if (identity.includes("Merchant")) {
    params["org"] = orgId;
    let { result, status } = await httpClient.get(`wallet/merchant/window/sale`, {params});
    return status === 200 ? result : {}
  } else {
    let { result, status } = await httpClient.get(`wallet/admin/window/sale`, {params});
    return status === 200 ? result : {}
  }
}

/*
  校园钱包/档口结算情况/食堂结算情况
*/
async function getSettleInfo(params, type) {
    if(type === "canteen") {
      let { result, status } = await httpClient.get(`wallet/canteen/settle/info`, {params});
      return status === 200 ? result : {}
    } else {
      let { result, status } = await httpClient.get(`wallet/window/settle/info`, {params});
      return status === 200 ? result : {}
    }
}

/*
  校园钱包/用户余额管理
*/
async function getUserBalance(params) {
    return await httpClient.get(`wallet/user/balance`, {params});
}

/*
  校园钱包/用户日志
*/
async function getUserBalanceRecord(params) {
    return await httpClient.get(`wallet/user/balance/record`, {params});
}

/*
  校园钱包/验证用户是否有充值权限
*/
async function verifyUserDeposit() {
    return await httpClient.get(`wallet/verify/user/deposit`);
}

/*
  校园钱包/用户个人充值记录
*/
async function userDepositRecordOne(params) {
    return await httpClient.get(`wallet/user/deposit/record/one`, {params});
}

/*
  校园钱包/用户冲正
*/
async function walletCorrect(params) {
    let data = await httpClient.post('wallet/correct', params);
    return data;
}
/*
  校园钱包/校园钱包流水退款
*/
async function walletRefund(params, identity) {
  if (identity.includes("Merchant")) {
    return await httpClient.get(`wallet/merchant/refund`, {params});
  } else {
    return await httpClient.get(`wallet/refund`, {params});
  }
}
/*
  校园钱包/冲账记录
*/
async function correctRecord(params) {
    return await httpClient.get(`wallet/correct/record`, {params});
}

/*
  校园钱包/下载表格
*/
async function getRecordDownload(params) {
    return await httpClient.get(`wallet/user/deposit/record/download`, {params});
}

/*
  校园钱包/下载附件
*/
async function getOrgRecordDownload(params) {
    return await httpClient.get(`wallet/org/deposit/record/download`, {params});
}

/*
  校园钱包/用户取消充值
*/
async function userDepositCancel(params) {
    let data = await httpClient.post('wallet/user/deposit/cancel', params);
    return data;
}

/*
  商户管理页 判断是否授权
*/

async function validAliAuth() {
    return await httpClient.get(`api/merchant/valid/aliAuth`);
}

/*
  商户管理页导出验证码
*/
async function merchantExport() {
    return await httpClient.get(`api/merchant/export`);
}

/*
  对账单下载 订单号查询
*/

async function queryFormWeChat(params, identity) {
  if (identity.includes("Merchant")) {
    return  await httpClient.post('api/order/query-from-wechat/merchant', params);
  } else {
    return  await httpClient.post('api/order/query-from-wechat', params);
  }
}

/*
  交易流水创建下载
*/

async function createTask() {
    return  await httpClient.post('api/download/log/create/task/new');
}

/*
  交易流水文件下载
*/

async function downloadList(params, orgId) {
    params.orgId = orgId
    return await httpClient.get(`api/download/log/page-list`, {params});
}

/*
  交易流水文件下载,点击下载按钮

*/

async function privateZip(params) {
    return await httpClient.get(`api/download/log/get/private/zip/url`, {params});
}

/*
  获取餐段列表
*/
async function getSectionList(params) {
    return await httpClient.get(`api/section/list`, {params});
}

/*
  删除餐段
*/
async function sectionDelete(params) {
    return await httpClient(params);
}

/**
 * 添改餐段
 * @param {*} params
 */
async function CRUD_Section(params) {
    return await httpClient(params);
}

/**
 *学校账户钱包列表
 *
 */
async function getWalletSimple(identity) {
    if(identity && identity.includes("Merchant")) {
        return await httpClient.get(`wallet/org/walletsimple-list/merchant`);
    } else {
        return await httpClient.get(`wallet/org/wallet/list`);
    }

}

/**
 *查询学校账户钱包详情
 *
 */
async function getWalletDetail(params) {
   return await httpClient.get(`wallet/org/wallet/detail`, {params});
}

/**
 *更新学生信息
 *
 */
async function walletUserUpdate(params) {
    let data = await httpClient.post('wallet/user/update', params);
    return data;
}


/**
 *新建校园钱包
 *
 */
async function walletAdd(params) {
    let data = await httpClient.post('wallet/org/wallet/add', params);
    return data;
}

/**
*获取图标列表
*
*/
async function iconList(params) {
    let data = await httpClient.get('wallet/icon/list', {params});
    return data;
}

/**
*修改校园钱包
*
*/
async function walletUpdate(params) {
    let data = await httpClient.post('wallet/org/wallet/update', params);
    return data;
}


/**
*获取账户详情
*
*/
async function walletDetail(params) {
    let data = await httpClient.get('wallet/org/wallet/detail', {params});
    return data;
}

/**
*获取账户详情
*
*/
async function walletStatus(params) {
    let data = await httpClient.post('wallet/org/wallet/status', params);
    return data;
}

/**
*获取用户过期金额
*
*/
async function walletUserBalanceExpire(params) {
    let data = await httpClient.post('wallet/user/balance/expire/list', params);
    return data;
}

/**
*查询用户钱包信息
*
*/
async function userWalletList(params) {
    let data = await httpClient.get('wallet/user-wallet/list', {params});
    return data;
}

/**
*查询用户钱包信息
*
*/
async function userWalletGet(params) {
    let data = await httpClient.get('wallet/user-wallet/get', {params});
    return data;
}

/**
*商户登录切换学校
*
*/
async function merchantChangeTo(params) {
    let data = await httpClient.get('merchant-api/v2/change-to', {params});
    return data;
}

/*
*查询资金管理页导出档口结算PDF按钮显示
*/
async function checkShowBtn(params) {
    let data = await httpClient.get(`api/pdf/download/auth/check-show-btn`, { params });
    return data;
}

/*
*微信商户号分账个人账号列表
*/
async function getWxProfitsharingPms(params) {
    let data = await httpClient.get(`api/wx/profitsharing/pms`, { params });
    return data;
}

/*
*获取分账的微信账号
*/
async function getWxProfitsharing(params) {
    let data = await httpClient.get(`api/wx/profitsharing/accounts`, { params });
    return data;
}

/*
*管理员添加分账人员信息
*/
async function setWxProfitsharing(params) {
  return await httpClient(params);
}

/*
*获取通告信息
*/
async function getSysnotice(orgId) {
    let { result } = await httpClient.get(`api/admin/sysnotice/detail`, { params: {orgId} });
    return result;
}

/*
*已取公告信息
*/
async function sysnoticeRead(params) {
    let data = await httpClient.post('api/admin/sysnotice/read', params);
    return data;
}

/*
*获取验证码
*/
async function getCaptcha(params) {
    let data = await httpClient.post(`api/captcha/get`, params);
    return data;
}

/*
*检查验证码是否正确
*/
async function checkCaptcha(params) {
    let data = await httpClient.post('api/captcha/check', params);
    return data;
}

/*
*是否设置隔日退款
*/
async function getRefundLimit(params) {
    let data = await httpClient.get(`api/order/refund/limit`, { params });
    return data;
}

async function request(params) {
  const url = params._url;
  delete params._url;
  const method = params._method || "post";
  delete params._method;
  const message = params._message;
  delete params._method;
  let data = {};
  if(method === "post") {
    data = await httpClient.post(url,  params );
  } else {
    data = await httpClient.get(url, { params });
  }
  if(!message && (data.status !== 200)){
    Message.warning(data.message);
  }
  return data;
}

export {
    commonLogin,
    logout,
    returnToSysAdmin,
    getQRCodeSrc,
    checkQRCodeStatus,
    checkQRcodeIdentity,
    skipBind,
    updatePassword,
    getUserBaseInfo,
    getUserAuthInfo,
    getPaySetList,
    getPayChannel,
    getAdminMenu,
    getMerchantMenu,

    getOverViewDataStatis,
    getOverViewDailySales,
    getOverViewDayRank,

    getCanteenList,
    getOrderList,
    submitRefund,

    getDeviceList,
    CRUD_Device,
    CRUD_Window,
    CRUD_Centeen,
    CRUD_Merchant,
    getDeviceQRCode,
    getCbChannel,
    addCb,
    delCb,
    delCbRule,
    getCbOne,
    getCbRule,
    getCbList,
    updateCbOne,
    getECardTypes,
    getBrand,
    getCanbuList,
    getWeakOrderList,
    getWeakOrderOne,
    getWeakDeviceList,
    getWeakBlackList,
    setWeakPay,
    getPayChannelByOrgCode,
    getStatementUrl,
    getAliPayStatementUrl,
    getFundsOrderList,
    getFundsDownOrderList,
    downFundsDownOrderList,
    getMerchantList,

    getMerchantOrgList,
    bindMerchantAccount,
    getSchoolList,
    getAliUserInfo,
    unBindAliUser,
    CRUD_PM,

    getUserDepositRecord,
    getOrgDepositRecord,
    getUserDepositDetail,
    excelDetail,
    userDeposit,
    getStatistic,
    orgDeposit,
    getOrgDepositDetail,
    walletOrderList,
    getWindowSale,
    getSettleInfo,
    getOrgBalance,
    getUserBalance,
    getUserBalanceRecord,
    verifyUserDeposit,
    userDepositRecordOne,
    walletCorrect,
    walletRefund,
    correctRecord,
    validAliAuth,
    merchantExport,
    queryFormWeChat,
    createTask,
    downloadList,
    privateZip,
    getRecordDownload,
    getOrgRecordDownload,
    userDepositCancel,
    getSectionList,
    sectionDelete,
    CRUD_Section,
    getWalletSimple,
    getWalletDetail,
    walletUserUpdate,
    walletAdd,
    walletUpdate,
    iconList,
    walletDetail,
    walletStatus,
    userWalletList,
    userWalletGet,
    walletUserBalanceExpire,
    merchantChangeTo,
    checkShowBtn,
    checkPhone,
    sendCode,
    updatePhone,
    unbindOpenid,
    orgDepositReverse,
    weakRemoveId,
    request,
    getWxProfitsharingPms,
    getWxProfitsharing,
    setWxProfitsharing,
    getSysnotice,
    sysnoticeRead,
    getCaptcha,
    checkCaptcha,
    getRefundLimit
}



// WEBPACK FOOTER //
// ./src/api/index.js